import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import Config from '../../utils/config.service';
import symptomsEn from './data/symptoms.en.json';
import symptomsEt from './data/symptoms.et.json';
import symptomsFi from './data/symptoms.fi.json';
import symptomsRu from './data/symptoms.ru.json';

@Component({
	standalone: true,
	selector: 'card-symptoms',
	templateUrl: './card-symptoms.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class CardSymptomsComponent implements OnInit {
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private config: Config = inject(Config);
	private symptomsByLanguage: any = {
		en: symptomsEn,
		et: symptomsEt,
		fi: symptomsFi,
		ru: symptomsRu
	};
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.angularHelperService.createTimer(() => {
			this.getSymptomsList();
		}, 200);
	}
	
	getSymptomsList() {
		var user: any = this.session.getSession().user;
		var language: any = (user.deviceLanguage || 'et_EE').slice(0, 2);
		
		var supportedLangs: Array<any> = ['et', 'en', 'ru', 'fi'];
		if (!supportedLangs.includes(language)) {
			language = 'en';
		}

		this.vm.symptoms = (this.symptomsByLanguage[language] || []).map((symptom) => {
			return {
				...symptom,
				link: this.getPublicSymptomLink(symptom.link)
			};
		});
		this.vm.initialized = true;
	}

	getPublicSymptomLink(link) {
		if (!link || /^https?:\/\//i.test(link)) {
			return link;
		}
		var normalizedLink: any = link.startsWith('/') ? link : '/' + link;
		return this.config.getPublicWebUrl() + normalizedLink;
	}
	
}
